export default "__VITE_ASSET__95b6567f__"